document.addEventListener("scroll", function() {
    let img = document.getElementById("movingImage");
    if (!img) return; // Prevents errors if the element isn't found

    let imgPosition = img.getBoundingClientRect().top;
    let screenHeight = window.innerHeight / 1.2;

    if (imgPosition < screenHeight) {
        img.classList.add("active"); // Moves in when scrolling down
    } else {
        img.classList.remove("active"); // Moves back when scrolling up
    }
});

document.addEventListener("scroll", function() {
    let diagram = document.querySelector(".animated-img2");
    if (!diagram) return; // Prevent errors if the element is missing

    let diagramPosition = diagram.getBoundingClientRect().top;
    let screenHeight = window.innerHeight / 1.2;

    if (diagramPosition < screenHeight) {
        diagram.classList.add("active"); // Fade and move in
    } else {
        diagram.classList.remove("active"); // Reverse when scrolling up
    }
});